import React, { Component } from 'react';

import UIWidth from './UIWidth'

class MainGreyBackground extends Component {
  render() {
    return (
      <UIWidth backgroundColor="#e9eaea" collapseMargins={this.props.collapseMargins} marginBottom={this.props.marginBottom}>
        {this.props.children}
      </UIWidth>
    );
  }
}

export default MainGreyBackground;